import {TemplateTypesEnum} from '../enum/email-templates.enum'
export class EmailTemplate {
    constructor() {
    }
    _id: string;
    application_id: any=null;
    templateId: string;
    to: string;
    subject: string;
    emailBody: string;
    isActive: boolean;
    availableMergeFields: string;
    appDetail:Object;
    organization_id:any;
    type:TemplateTypesEnum.ORGANIZATION|TemplateTypesEnum.APPLICATION|TemplateTypesEnum.TENET
    //copy object properties
    public map(source: EmailTemplate): void {
        Object.keys(source).map((key, index) => {
            this[key] = source[key];
        });
    }
}
